import { AppMobileWrapper } from './Mobile/AppMobile';
import { Router } from './Router/Router';
import { useUiContext } from './components/Contexts/UIContext/uiCtx';
import { useLanguageSynchronizer } from './localization/hooks';
import './localization/init'; // Import the i18n configuration

export const App: React.FC = () => {
    const { isInPhoneMode } = useUiContext();
    useLanguageSynchronizer();
    return <>{isInPhoneMode ? <AppMobileWrapper /> : <Router />}</>;
};
